export const VERIFY_EMAIL = '@komigen/mobile-frontend/authentication/VERIFY_EMAIL';
export const VERIFY_CODE = '@komigen/mobile-frontend/authentication/VERIFY_CODE';
export const UPDATE_PASSWORD = '@komigen/mobile-frontend/authentication/UPDATE_PASSWORD';
export const CHANGE_PASSWORD_LOGIN = '@komigen/mobile-frontend/authentication/CHANGE_PASSWORD_LOGIN';
export const UPDATE_STATUS = '@komigen/mobile-frontend/authentication/UPDATE_STATUS';
export const CLOSE_MESSAGE = '@komigen/mobile-frontend/authentication/CLOSE_MESSAGE';
export const VERIFY_CODE_FAILURE = '@komigen/mobile-frontend/authentication/VERIFY_CODE_FAILURE';
export const UPDATE_RESET_PASSWORD_CREDENTIALS =
	'@komigen/mobile-frontend/authentication/UPDATE_RESET_PASSWORD_CREDENTIALS';
export const RESET_PASSWORD_RESET = '@komigen/mobile-frontend/authentication/RESET_PASSWORD_RESET';
export const SHOW_DOB_FORGETPASSWORD = '@komigen/mobile-frontend/authentication/SHOW_DOB_FORGETPASSWORD';
export const SET_DATE_OF_BIRTH = '@komigen/mobile-frontend/authentication/SET_DATE_OF_BIRTH';
